<template>
  <div class="row g-3">
    <div class="col-6 col-xl" v-for="c in cards" :key="c.key">
      <div class="card h-100">
        <div class="card-body">
          <p class="text-muted mb-2 small">{{ c.label }}</p>
          <span class="h2 fw-bold mb-0">{{ numberBR(data[c.key]) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { numberBR } from "@/utils/dashboardCharts";

export default {
  name: "DashBigNumbers",
  props: { data: { type: Object, required: true } },
  data() {
    return {
      cards: [
        { key: "psy_subscribers", label: "Total de Psis Assinantes" },
        { key: "patients", label: "Total de pacientes" },
        { key: "psys", label: "Total de psis" },
        { key: "psys_approved", label: "Total de psis aprovados" },
        {
          key: "successful_appointments",
          label: "Sessões agendadas e concluídas",
        },
      ],
    };
  },
  methods: { numberBR },
};
</script>
